import moment from "moment";
import { parseAction } from "./REST";
import config from "../config";

export const organizationDashboard = () => (dispatch) => {

  return parseAction(
    "post",
    config.BASE_URL + "/parse/functions/organizationDashboard"
  ).then((response) => {
    return response.result;
  });
};